import { configureStore } from '@reduxjs/toolkit';
import user from './user/reducer';
import form from './form/reducer';

export const store = configureStore({
  reducer: {
    user,
    form,
  },
});
